
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/agents.json",
      function () {
        return require("private-next-pages/agents.json.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/agents.json"])
      });
    }
  